import React from 'react';
import ReactDOM from 'react-dom';
import { initReactI18next } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { configureStore } from '@reduxjs/toolkit';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import App from './App';
import { getFromLocalStorage } from './Functions/LocalStorageUtils';
import cs from './locales/cs.json';
import en from './locales/en.json';
import { authApi } from './redux/api/auth';
import { configurationsApi } from './redux/api/configurations';
import authCheck from './redux/middleware/authCheck';
import { rtkQueryErrorLogger } from './redux/middleware/errorHandler';
import { rootReducer } from './redux/reducers';

// Later add wssMiddleware now is removed due to issues with typing
export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authCheck,
      authApi.middleware,
      configurationsApi.middleware,
      rtkQueryErrorLogger,
    )
});

let locale = getFromLocalStorage('inels-locale');

if (!locale) {
  locale = 'en';
}

document.documentElement.style.setProperty('--color-primary', '#0091ea');
document.documentElement.style.setProperty('--color-primary-dark', '#0d47a1');
document.documentElement.style.setProperty('--color-primary-light', '#abdaf9');


const faviconHref = `${process.env.PUBLIC_URL || ''}/inels_logo_small.svg`;

let faviconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
if (!faviconLink) {
  faviconLink = document.createElement('link');
  faviconLink.rel = 'icon';
  document.head.appendChild(faviconLink);
}
faviconLink.type = 'image/svg+xml';
faviconLink.href = faviconHref;

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      cs: { translation: cs }
    },
    lng: locale,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
